import { SelectCustomizable } from 'ui';
import FooterButtons from 'core/modules/compositions/FooterButtons';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { withTranslation } from 'react-i18next';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';
import { getSectionTypes } from '../../../../crud/sectionTypes.crud';

// import Icon from '../../atoms/Icon';
// import { lessonType } from '../../../variables/constant';

const NewSectionForm = ({ t, onCancel, onSuccess, dataEdit, isPublisherMode, lesson }) => {
  const { register, handleSubmit, errors, control } = useForm();
  const [titleLesson, setTitleLesson] = useState('');
  const [typeSection, setTypeSection] = useState(dataEdit ? dataEdit.section_type_guid : 'default');
  const [types, setTypes] = useState([]);

  const getTypes = async () => {
    const _types = await getSectionTypes();
    if (_types?.data && _types.data.status === 'success') {
      let typesOfSection = _types?.data.data;
      typesOfSection = typesOfSection.map((type) => {
        return { label: type.name, value: type.guid, is_editable: type.is_editable };
      });
      setTypes(!isPublisherMode ? typesOfSection.filter((type) => type.is_editable === 1) : typesOfSection);
    }
  };

  useEffect(() => {
    getTypes();
    register({ name: 'title' }, { required: true });
    if (dataEdit) {
      setTitleLesson(dataEdit.name);
      setTypeSection(dataEdit.section_type_guid);
    }
  }, []);

  function onSubmit(data) {
    onSuccess({ ...data, section_type_guid: typeSection, guid: dataEdit ? dataEdit.guid : null });
    onCancel();
  }

  function onClickSuccess() {}

  function onClickCancel(e) {
    e.preventDefault();
    e.stopPropagation();
    onCancel();
  }

  function getTypeNameAndValue(value) {
    return types.filter((type) => type.value === value) || typeSection;
  }

  return (
    <div className="new-lesson-form">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="new-lesson-form__form">
          <div className="new-lesson-form__big">
            <FormField
              error={!!errors.title}
              errorMessage={t('common:Required parameter')}
              label={t('lesson:Give a name to your section')}
            >
              <InputText
                placeholder={t('lesson:Example Additional content')}
                name="title"
                referer={register({ required: true })}
                value={titleLesson}
                onChange={(e) => {
                  setTitleLesson(e.currentTarget.value);
                }}
              />
            </FormField>
          </div>
          {types.length > 1 && (
            <div className="new-lesson-form__big">
              <SelectCustomizable
                label={t('new-lesson:Section type')}
                options={types}
                defaultValue={getTypeNameAndValue(typeSection)}
                value={getTypeNameAndValue(typeSection)}
                onChange={(e) => setTypeSection(e.value)}
              />
            </div>
          )}
        </div>
        <div className="new-lesson-form__buttons">
          <FooterButtons
            buttonTextCancel={t('actions:Cancel')}
            buttonTextSucess={dataEdit?.guid ? t('actions:Save') : t('actions:Create')}
            onCancel={onClickCancel}
            onSuccess={onClickSuccess}
          />
        </div>
      </form>
    </div>
  );
};

NewSectionForm.propTypes = {
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  dataEdit: PropTypes.object,
  isPublisherMode: PropTypes.bool,
  lesson: PropTypes.object,
};

NewSectionForm.defaultProps = {
  onCancel: function () {},
  onSuccess: function () {},
};

export default withTranslation(['lesson', 'common', 'placeholder', 'actions'])(NewSectionForm);
